import UserSupport from '@/screens/userSupport'
import FunctionalitySupport from '@/screens/userSupport/FunctionalitySupport'
import BugSupport from '@/screens/userSupport/BugSupport'

const routes = [
  {
    path: '/user-support',
    name: 'UserSupport',
    component: UserSupport,
    meta: { requireAuth: true }
  },
  {
    path: '/functionality-support',
    name: 'FunctionalitySupport',
    component: FunctionalitySupport,
    meta: { requireAuth: true }
  },
  {
    path: '/bug-support',
    name: 'BugSupport',
    component: BugSupport,
    meta: { requireAuth: true }
  }
]

export default routes
